// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// ANTD
import message from 'antd/lib/message';
import Button from 'components/common/Button';
import Icon from 'components/common/Icon';
import Popconfirm from 'antd/lib/popconfirm';
import 'antd/lib/popconfirm/style/css';
// APOLLO
import { graphql, compose } from 'react-apollo';
import deleteSession from 'ApolloClient/Mutations/deleteSession';
import deleteLineItem from 'ApolloClient/Mutations/deleteLineItem';
import deleteQuestionTemplate from 'ApolloClient/Mutations/deleteQuestionTemplate';
import lineItemsQuery from 'ApolloClient/Queries/lineItems';
import sessionsQuery from 'ApolloClient/Queries/sessions';
import sessionsByClientIdQuery from 'ApolloClient/Queries/sessionsByClientId';
import questionTemplatesQuery from 'ApolloClient/Queries/questionTemplates';
import invoicesQuery from 'ApolloClient/Queries/invoices';
import invoicesByClientIdQuery from 'ApolloClient/Queries/invoicesByClientId';


export class DeleteButton extends React.Component {
  state = {
    loading: false,
  };

  onConfirm = () => {
    const {
      id, record, deleteFunc, itemType,
    } = this.props;

    this.setState({ loading: true });

    const variables = { _id: id };
    const refetchQueries = [
      { query: lineItemsQuery, variables },
      { query: questionTemplatesQuery },
      { query: sessionsQuery },
      { query: invoicesQuery },
    ];

    if (record && record.client && record.client._id) {
      if (itemType === 'Session') {
        const sessionQuery = {
          query: sessionsByClientIdQuery,
          variables: { _id: record.client._id },
        };
        refetchQueries.push(sessionQuery);
      } else if (itemType === 'Invoice') {
        const invoiceQuery = {
          query: invoicesByClientIdQuery,
          variables: { _id: record.client._id },
        };
        refetchQueries.push(invoiceQuery);
      }
    }

    this.props[deleteFunc]({ variables, refetchQueries })
      .then(() => {
        this.setState({ loading: false });
        message.success('successfully deleted!', 3);
      })
      .catch(err => {
        console.log(err);
        this.setState({ loading: false });
        message.success('Something bad happened!', 3);
      });
  };

  render() {
    const { itemType } = this.props;
    const { loading } = this.state;

    return (
      <Popconfirm
        title={`Are you sure you want to delete this ${itemType}?`}
        onConfirm={this.onConfirm}
        okText="Yes"
        cancelText="No"
      >
        <Button type="danger" loading={loading}>
          <Icon type="delete" />
        </Button>
      </Popconfirm>
    );
  }
}

DeleteButton.propTypes = {
  id: PropTypes.string.isRequired,
  record: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    // as well as other fields
  }).isRequired,
  itemType: PropTypes.string.isRequired,
  deleteFunc: PropTypes.string.isRequired,
};

const enhance = compose(
  graphql(deleteSession, { name: 'deleteSession' }),
  graphql(deleteLineItem, { name: 'deleteLineItem' }),
  graphql(deleteQuestionTemplate, { name: 'deleteQuestionTemplate' }),
);

export default enhance(DeleteButton);



// WEBPACK FOOTER //
// ./src/components/common/DeleteButton/index.js